<template>
  <FreeBottomSheet :name="name">
    <template #default="{ hide }">
      <div class="p-4">
        <div class="bg-background-neutral-secondary space-y-4 rounded-3xl p-4">
          <img
            width="144"
            height="144"
            src="../assets/gift.webp"
            class="mx-auto size-36"
            alt=""
            loading="lazy"
            decoding="async"
          />
          <span
            class="bg-background-positive-muted mx-auto flex w-fit items-center gap-1 rounded-[20px] px-2 py-0.75"
          >
            <ClockIcon class="text-text-positive-primary" />
            <span class="text-text-positive-primary text-2xs font-medium">
              {{ promo.daysLeftText.value }}
            </span>
          </span>
          <div class="space-y-2 text-center">
            <p class="text-text-neutral-primary text-xl font-bold text-balance">
              {{
                t('avia-tour-promo.title-suffix', {
                  sum: promo.discountAmountText,
                })
              }}
            </p>
            <p class="text-text-neutral-tertiary">
              {{ t('avia-tour-promo.activate-hint') }}
            </p>
          </div>
          <div class="space-y-2">
            <CopyButton
              :text="promo.promocode"
              class="bg-background-neutral-onblock w-full rounded-2xl p-4"
              @onCopy="handleCopy"
            >
              <span
                class="text-text-neutral-primary text-lg font-medium uppercase"
              >
                {{ promo.promocode }}
              </span>
              <template #icon>
                <CopyIcon class="text-[#17E860]" />
              </template>
            </CopyButton>

            <div
              class="bg-background-info-primary/8 flex items-start gap-3 rounded-2xl py-2 pr-5 pl-3"
            >
              <ScreenshotIcon />
              <div class="space-y-0.5">
                <p class="text-text-info-primary text-sm font-semibold">
                  {{ t('avia-tour-promo.save-tip-title') }}
                </p>
                <p class="text-text-info-primary text-2xs">
                  {{ t('avia-tour-promo.save-tip-description') }}
                </p>
              </div>
            </div>
          </div>
          <FreeButton
            class="green-main-button w-full"
            type="button"
            @click="handleCtaClick(hide)"
          >
            {{ t('avia-tour-promo.select-tour') }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeBottomSheet>

  <div class="fixed inset-x-0 bottom-20 z-1001 flex justify-center">
    <FreeAlert ref="alertRef" class="flex justify-center" :duration="3000">
      <template #icon>
        <CheckCircleIcon class="text-text-positive-primary" />
      </template>
      <span>{{ t('avia-tour-promo.promocode-copied') }}</span>
    </FreeAlert>
  </div>
</template>

<script setup lang="ts">
  import { useTemplateRef } from 'vue';
  import { useI18n } from 'vue-i18n';

  import {
    FreeAlert,
    FreeBottomSheet,
    FreeButton,
    CopyButton,
  } from '../../../shared/ui';
  import ClockIcon from '../../../assets/icons/16/clock.svg?component';
  import CopyIcon from '../../../assets/icons/24/copy.svg?component';
  import CheckCircleIcon from '../../../assets/icons/24/check-circle.svg?component';
  import ScreenshotIcon from '../assets/screenshot.svg?component';
  import { useAviaTourPromo } from '../model/use-avia-tour-promo.ts';
  import messages from '../locales.json';

  defineProps<{
    name: string;
  }>();

  const emit = defineEmits<{
    onCtaClick: [];
  }>();

  const { t } = useI18n({ messages });
  const promo = useAviaTourPromo();

  const alertRef = useTemplateRef('alertRef');

  const handleCopy = () => {
    alertRef.value?.show();
  };

  const handleCtaClick = (hide: () => void) => {
    emit('onCtaClick');
    hide();
  };
</script>
